import { MultiStepHandle } from './types';
import useQueryParamStep from './useQueryParamStep';
import useStateStep from './useStateStep';

type UseMultiStepProps = {
  handle?: MultiStepHandle;
  formName?: string;
  initialStep: string;
};

export const useMultiStep = ({
  handle = 'queryParam',
  formName,
  initialStep,
}: UseMultiStepProps) => {
  const useMultiStepState = handle === 'state' ? useStateStep : useQueryParamStep;
  const { inViewStep, setStep } = useMultiStepState({ formName, initialStep });

  return {
    inViewStep,
    setStep,
  };
};
